<!-- Application Tiles Section -->
<div class="mb-8 pl-10">
  <h1>Your Applications</h1>
  <app-application-tiles />
</div>
